// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { OperatorConfiguration } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Configuration/Operator';
import { ERR_ARC_OP_CONF, SUC_ARC_OP_CONF } from '../../../../utils/strings';

export const useArchiveOperatorConfiguration = () => {
  const { submit } = useExerciseSubmission(
    OperatorConfiguration.Archive,
    SUC_ARC_OP_CONF,
    ERR_ARC_OP_CONF,
  );
  return submit;
};
